// eslint-disable-next-line
import NetworkFactory from './networkFactory';

export const NETWORK_SERVICES = {
  AXIOS: 'axios'
};

export default class NetworkRepository {
  constructor(service = NETWORK_SERVICES.AXIOS) {
    this.service = new NetworkFactory(service);
  }

  get = ({ params = {}, url, config = {} }) =>
    this.service.get(url, params, config);

  post = ({ data = {}, url, config = {} }) =>
    this.service.post(url, data, config);

  put = ({ data, url, config = {} }) => this.service.put(url, data, config);

  delete = ({ data, url, config = {} }) =>
    this.service.delete(url, data, config);
}
